import { render } from "./JointSessions.vue?vue&type=template&id=61cb371a"
import script from "./JointSessions.vue?vue&type=script&lang=js"
export * from "./JointSessions.vue?vue&type=script&lang=js"

import "./JointSessions.vue?vue&type=style&index=0&id=61cb371a&lang=scss"

import exportComponent from "/home/admin/swarm-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__